import { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import { getFileIconClass, isImage } from "../../../utils/helpers";
import { UserType } from "../../../utils/enum";
import EditCustomerFilesModal from "../components/EditCustomerFilesModal";

const Documents = ({ customerFiles, authRole, hasUpdateAccess }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <BaseCard className="pt-4 pb-6 xl:px-16 px-5 rounded-lg !mb-[0px]" elevation={1}>
      <div className="border-bottom mb-4 flex items-center">
        <h6 className="mb-1 text-dark">Client Documents</h6>
        {/* hasUpdateAccess is canEditDetails, which already narrows a customer to
            their own reach and to the statuses they may still shape. */}
        {(authRole === UserType.CLIENT || authRole === UserType.CUSTOMER) && hasUpdateAccess && (
          <i
            className="fa-light fa-pencil text-gray-900 ml-3 cursor-pointer"
            onClick={() => setIsModalOpen(true)}
          ></i>
        )}
      </div>

      <div className="grid grid-cols-2 gap-4 py-3">
        {customerFiles?.map((file, index) => (
          <div className="bg-[#F6F6F6] rounded-md mt-4" key={index}>
            <div className="flex justify-between px-4 py-2 items-center">
              <div className="flex items-center">
                {isImage(file.filename) ? (
                  <img
                    className="h-14 w-14 rounded-md object-cover"
                    src={file?.url}
                    alt={file.filename}
                  />
                ) : (
                  <div className="h-14 w-14 rounded-md bg-gray-100 flex items-center justify-center">
                    <i className={`fa-solid ${getFileIconClass(file.filename)} text-[40px]`} />
                  </div>
                )}
                <div className="ml-3">
                  <p className="font-normal">{file?.filename}</p>
                  {/* <p>7/23/2024 at 2:43 AM EDT</p> */}
                  {/* <p>
                      Uploaded by: 
                      <span className="text-secondary">Istkhar Hussain</span>
                    </p> */}
                </div>
              </div>
              <div>
                <i
                  className="fa-solid fa-eye cursor-pointer"
                  title="View File"
                  onClick={() => window.open(file.url, "_blank")}
                ></i>
                {/* <i className="fa-regular fa-trash-can ml-3"></i> */}
              </div>
            </div>
          </div>
        ))}
      </div>
      {isModalOpen && (
        <EditCustomerFilesModal
          open={isModalOpen}
          close={() => setIsModalOpen(false)}
          workOrderCustomerFiles={customerFiles}
        />
      )}
    </BaseCard>
  );
};

export default Documents;
